import RouteTemplate from 'ember-route-template';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { on } from '@ember/modifier';
import { fn } from '@ember/helper';
import TopNav from '../components/layout/top-nav/main';
import InventoryBagPreview from '../components/layout/inventory-bag-preview';
import Footer from '../components/layout/footer';
import SvgSheet from '../helpers/svgsheet';
import SearchCommandPalette from '../components/search-command-palette';
import CommandPalette from '../components/command-palette';
import { keyResponder, onKey } from 'ember-keyboard';
import Head from '../components/head';
import { pageTitle } from 'ember-page-title';

@keyResponder({ priority: 1 })
class ApplicationRouteComponent extends Component {
  @tracked isBagOpen = false;
  @tracked isSearchOpen = false;
  @tracked isCommandPaletteOpen = false;
  @tracked isMobileMenuOpen = false;

  @action setIsBagOpen(state) {
    this.isBagOpen = state;
  }
  @action setIsSearchOpen(state) {
    this.isSearchOpen = state;
  }
  @action setIsCommandPaletteOpen(state) {
    this.isCommandPaletteOpen = state;
  }
  @action setIsMobileMenuOpen(state) {
    this.isMobileMenuOpen = state;
  }
  @onKey('w')
  scrollUp() {
    scrollBy(0, -34);
  }
  @onKey('shift+w')
  pageUp() {
    scrollBy(0, -959);
  }
  @onKey('s')
  scrollDown() {
    scrollBy(0, 34);
  }
  @onKey('shift+s')
  pageDown() {
    scrollBy(0, 959);
  }
  @onKey('ctrl+k')
  @onKey('meta+k')
  async openCommandPalette(e, ek) {
    if (ek && typeof ek.preventDefault === 'function') {
      ek.preventDefault();
    } else if (e && typeof e.preventDefault === 'function') {
      e.preventDefault();
    }
    await timeout(20);
    this.setIsCommandPaletteOpen(true);
  }

  <template>
    {{pageTitle '1vX.gg'}}
    <Head />
    <TopNav
      @openBag={{this.setIsBagOpen}}
      @openSearch={{this.setIsSearchOpen}}
      @openMobileMenu={{this.setIsMobileMenuOpen}}
      @isMobileMenuOpen={{this.isMobileMenuOpen}}
    />
    <InventoryBagPreview @isBagOpen={{this.isBagOpen}} @closeBag={{this.setIsBagOpen}} />
    {{#if this.isSearchOpen}}
      <SearchCommandPalette @isOpen={{this.isSearchOpen}} @onClose={{fn this.setIsSearchOpen false}} />
    {{/if}}
    {{#if this.isCommandPaletteOpen}}
      <CommandPalette @isOpen={{this.isCommandPaletteOpen}} @close={{this.setIsCommandPaletteOpen}} />
    {{/if}}
    {{outlet}}
    <Footer />
    {{{SvgSheet}}}
  </template>
}

export default RouteTemplate(ApplicationRouteComponent);

function timeout(wait = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve.bind(this, wait), wait);
  });
}
